import { AbstractFilter } from "../types/AbstractFilter"
import { FilterRequest, ProductGroupFilterRequest } from "../types/request"

/**
 * Filter element restricting the product selection to a given product group.
 *
 * Must not be used in conjunction with ProductsFilter, CharacteristicFilter or BoolFilter, otherwise service responds with status code 400 (Bad Request).
 */
export class ProductGroupFilter implements AbstractFilter {
    private filter: ProductGroupFilterRequest

    constructor() {
        this.filter = {
            id: null,
            returnProductsOfChildProductGroups: false
        }
    }

    /**
     * ID of a product group.
     * @param {String} pid the product group id
     * @return this
     */
    id(pid: string): this {
        this.filter.id = pid
        return this
    }

    /**
     * Whether the response should contain the products of the child product groups of the requested product group. Default: false
     * @param {bool} subgroups include subgroups ?
     * @return this
     */
    includeSubgroups(subgroups: boolean): this {
        this.filter.returnProductsOfChildProductGroups = subgroups
        return this
    }

    build(): FilterRequest {
        return {
            productGroupFilter: this.filter
        }
    }
}
